import { createTheme } from "@mui/material";
import { PRIMARY_COLOR, SECONDARY_COLOR } from "./colors";

export const muiTheme = createTheme({
  palette: {
    primary: {
      main: PRIMARY_COLOR,
    },
    secondary: { main: SECONDARY_COLOR },
  },
  components: {
    MuiDialog: {
      styleOverrides: {
        paper: { borderRadius: 10 },
      },
    },
  },
});

export const antdTheme = {
  token: {
    colorPrimary: PRIMARY_COLOR,
    secondaryColor: SECONDARY_COLOR,
  },
  components: {
    Segmented: {
      itemSelectedBg: SECONDARY_COLOR,
      itemSelectedColor: "white",
    },
    Progress: {
      circleTextColor: "white",
    },
  },
};
